import React from 'react';
import type { ActionButtonConfig } from '../types';

const variantClasses: Record<string, string> = {
  default: 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50',
  primary: 'bg-sky-600 text-white border-sky-600 hover:bg-sky-700',
  danger: 'bg-red-600 text-white border-red-600 hover:bg-red-700',
};

export function MapActionButton({ icon: Icon, label, onClick, variant = 'default' }: ActionButtonConfig) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium border transition-colors min-h-[44px] ${variantClasses[variant]}`}
      aria-label={label}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {label}
    </button>
  );
}
